import { createFileRoute } from "@tanstack/react-router";
import {
    McpConnectionLinkLanding,
    mcpConnectionLinkLandingRoute,
} from "@/features/mcp-connections";

export const Route = createFileRoute("/kits/connect/")({
    ...mcpConnectionLinkLandingRoute,
    component: McpConnectionLinkLanding,
});
